<template>
  <!-- 学习页面 -->
  <!-- <open-app-bar
    class="fixed-top c-top"
    :style="{transform: 'translateY('+topBarTop + 'px)'}"
    :open-app-info="{
        jumpType: 2,
        resourceId: resourceId,
        goodsType: goodsType,
        goodsId: goodsId,
  }"
  ></open-app-bar>-->
  <div class="wrapper" v-wechat-title="article.name">
    <div
      v-if="article.materialType == constants.materialType.text || article.materialType == constants.materialType.audio"
    >
      <div class="c-default-img">
        <img v-if="article.image" :src="article.image" alt />
      </div>
    </div>
    <div
      class="c-video"
      :style="{transform: 'translateY('+topBarTop + 'px)'}"
      :class="{
        hideVideo: article.materialType != constants.materialType.video,
        fixedVideo: article.materialType == constants.materialType.video,
      }"
    >
      <div v-if="article.materialType != constants.materialType.text" id="J_prismPlayer"></div>
    </div>
    <div
      class="c-content-wrap hideVideo"
      :class="article.materialType == constants.materialType.video ? 'isVideo':''"
      ref="c-content-wrap"
    >
      <div class="c-label tl">{{article.name}}</div>
      <div class="c-other-info tl">
        <span v-if="article.teacherName">文章作者 | {{article.teacherName}}</span>
        <span v-if="article.editorName">责任编辑 | {{article.editorName}}</span>
      </div>
      <div
        class="c-audio"
        :style="{transform: 'translateY('+topBarTop + 'px)'}"
        v-if="article.materialType == constants.materialType.audio"
      >
        <audio-player
          v-model="startTime"
          :player="player"
          :title="article.name"
          :mediaReadPercent="article.mediaReadPercent"
          :timeLong="currentStream.duration"
          :img="article.teacherHeaderImage"
          @handlePlay="handlePlayAudio"
          :playing="playing"
        ></audio-player>
      </div>
      <div class="c-article tl" v-html="article.content"></div>
    </div>
  </div>
  <GxxtPageLoading v-show="showLoading"></GxxtPageLoading>
</template>

<script>
import { nextTick } from 'vue'
import { getAppScrollTop } from '@/utils/common'
import studySetup from './setup/study-setup'
import { GxxtPageLoading } from '@/components'
import audioPlayer from '../course/components/player'
import { wxShare } from '@/utils/wx-config'

export default {
  setup(props) {
    const {
      player,
      article,
      goodsType,
      goodsId,
      showLoading,
      resourceId,
      currentStream,
      storeStudyProgress,
    } = studySetup()
    return {
      player,
      article,
      goodsType,
      goodsId,
      showLoading,
      resourceId,
      currentStream,
      storeStudyProgress,
    }
  },
  data() {
    return {
      topBarHeight: 0,
      topBarTop: 0,
      timer: null,
      startTime: 0,
      playing: false,
    }
  },
  mounted() {
    nextTick(() => {
      this.topBarHeight = this.ratio * 90
      // this.bindScroll()
    })
  },
  methods: {
    openShare() {
      let shareInfo = {
        title: this.article.name,
        desc: this.article.shareDescription,
        link: this.article.shareLink,
        imgUrl: this.article.shareImage,
      }
      wxShare({ shareInfo })
    },
    bindScroll() {
      document.getElementById('app').addEventListener('scroll', this.scrollFun)
    },
    removeScroll() {
      document
        .getElementById('app')
        .removeEventListener('scroll', this.scrollFun)
    },
    throttle(fn, delay = 500) {
      let flag = true
      let self = this
      return (...args) => {
        if (!flag) return
        flag = false
        if (self.timer) return
        self.timer = setTimeout(() => {
          fn.apply(self, args)
          flag = true
          self.timer = null
          clearTimeout(self.timer)
        }, delay)
      }
    },
    scrollFun() {
      var scrollTop = getAppScrollTop()
      if (this.article.materialType != this.constants.materialType.audio) {
        if (scrollTop < this.topBarHeight) {
          this.topBarTop = -1 * scrollTop
        } else {
          this.topBarTop = -1 * this.topBarHeight - 2
        }
      }
      // 记录文稿进度
      let readHeight = scrollTop * 1 + this.window.height * 1 + 150
      let percent =
        (readHeight / this.$refs['c-content-wrap'].offsetHeight) * 100
      percent = percent.toFixed()
      // let fn = this.throttle(() => {
      //   this.storeStudyProgress(percent)
      // }, 1000)
      // fn()
    },
    handlePlayAudio(v) {
      this.playing = v
      if (this.playing) {
        this.player.play()
      } else {
        this.player.pause()
      }
    },
  },
  unmounted() {
    // this.removeScroll()
    this.player && this.player.dispose()
  },
  components: {
    GxxtPageLoading,
    audioPlayer,
  },
}
</script>

<style scoped lang="less">
.wrapper {
  overflow-x: hidden;
}
.c-top {
  transition: translate 0.3s linear;
}
.c-default-img {
  width: 100%;
  height: 422px;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
.c-audio {
  width: 686px;
  height: 140px;
  background-color: #fff;
  // position: fixed;
  // top: 130px;
  // left: 32px;
  margin: 30px auto;
}
.c-video {
  width: 750px;
  height: 422px;
  // background-color: #000;
  // position: fixed;
  // top: 90px;
  &.fixedVideo {
    position: fixed;
    top: 0;
    left: 50%;
    margin-left: -375px;
    right: 0;
    z-index: 99;
  }
}
.c-video.hideVideo {
  height: 0;
  overflow: hidden;
  opacity: 0;
}
.c-label {
  font-size: 36px;
  font-weight: 500;
  color: #333333;
  line-height: 64px;
  padding-top: 36px;
}
.c-other-info {
  font-size: 24px;
  font-weight: 500;
  color: #aaaaaa;
  padding: 26px 0 26px;
}
.c-content-wrap.hideVideo {
  padding: 0px 32px 100px;
}
.c-content-wrap {
  &.isVideo {
    padding: 420px 32px 100px;
  }
}

.c-article {
  font-size: 30px;
  line-height: 2.2;
  letter-spacing: 2px;
}
</style>